<template>
  <div class="page-table scrollable only-y">
    <div class="no-table-box page-header">
      <el-row class="hidden-sm-and-up pb-15">
        <h1>
          <v-svg class="voxo-orange" sprite="list" />
          Custom Destinations
        </h1>
      </el-row>
      <el-row class="hidden-xs-only pb-15">
        <el-col :span="12">
          <h1>
            <v-svg class="voxo-orange" sprite="list" />
            Custom Destinations
          </h1>
        </el-col>
        <el-col class="text-right" :span="12">
          <el-tag>
            <i class="el-icon-info" style="margin-right: 4px" />
            Total: {{ total }}
          </el-tag>
        </el-col>
      </el-row>

      <div class="flex pb-20">
        <div class="box">
          <el-input v-model="search" placeholder="Search" clearable />
          <el-button
            class="ml-10 hidden-xs-only"
            @click="doExport"
          >
            Export
          </el-button>
        </div>
        <div class="box right">
          <el-button @click="openCreateModal">Add New</el-button>
        </div>
      </div>

      <div class="vxe-table-height card-base card-shadow--medium">
        <vxe-grid
          round
          border="inner"
          ref="xGrid"
          height="100%"
          auto-resize
          empty-text="No Data"
          show-overflow="tooltip"
          highlight-hover-row
          @cell-click="cellClicked"
          @cell-mouseenter="rowHover"
          @cell-mouseleave="rowLeave"
          :data="tableData"
          :scroll-y="{enabled: true, gt: 50, oSize: 0}"
          :loading="tableLoading"
          :columns="tableColumns"
        />
      </div>
    </div>

    <create-form
      :createVisible="createVisible"
      :clearFormFields="clearFormFields"
      :createProcessing="createProcessing"
      :queueOptions="queueOptions"
      :numOptions="numOptions"
      :cidNumOptions="cidNumOptions"
      :mediafileOptions="mediafileOptions"
      :phonebookOptions="phonebookOptions"
      @remoteSearchNums="remoteSearchNums"
      @remoteSearchCidNums="remoteSearchCidNums"
      @createOperation="createOperation"
      @cancelOperation="cancelOperation"
    />

    <edit-form
      :editVisible="editVisible"
      :clearFormFields="clearFormFields"
      :editProcessing="editProcessing"
      :queueOptions="queueOptions"
      :numOptions="numOptions"
      :cidNumOptions="cidNumOptions"
      :mediafileOptions="mediafileOptions"
      :phonebookOptions="phonebookOptions"
      :selectedCustomDestination="selectedCustomDestination"
      @remoteSearchNums="remoteSearchNums"
      @remoteSearchCidNums="remoteSearchCidNums"
      @editOperation="editOperation"
      @cancelOperation="cancelOperation"
    />
  </div>
</template>

<script>
import { mapActions } from "vuex";
import feathersClient from "../../../feathers/feathers-client";
import { debounce } from "lodash";

import CreateForm from "./components/createForm";
import EditForm from "./components/editForm";
import {globalEventBus} from "../../../globalEventBus";
import {ExportToCsv} from "export-to-csv";

export default {
  name: "CustomDestinationsTable",
  data() {
    return {
      total: 0,
      eventChannel: null,
      createProcessing: false,
      editProcessing: false,
      deleteProcessing: false,
      tableLoading: false,
      tableData: [],
      allRecords: [],
      search: "",
      visibleActionsId: "",
      editVisible: false,
      createVisible: false,
      clearFormFields: false,
      selectedCustomDestination: null,
      queueOptions: [],
      numQuery: "",
      numOptions: [],
      cidNumQuery: "",
      cidNumOptions: [],
      mediafileOptions: [],
      phonebookOptions: [],
      tableColumns: [
        {
          field: 'sprite',
          title: '',
          width: 50,
          slots: {
            default: ({row}) => {
              return [
                <div class="voxo-square-icon voxo-bg-btn">
                  <v-svg class="voxo-orange" sprite="list"/>
                </div>
              ]
            }
          }
        },
        {
          field: 'name',
          title: 'Name',
          minWidth: 150,
          sortable: true
        },
        {
          field: 'customType.name',
          title: 'Type',
          minWidth: 150,
          sortable: true,
          showOverflow: true,
          slots: {
            default: ({row}) => {
              return [
                <span>{this.typeLookup(row.ctId)}</span>
              ]
            }
          }
        },
        {
          field: 'actions',
          title: '',
          minWidth: '150',
          showOverflow: false,
          slots: {
            default: ({row}) => {
              return [
                <div v-show={row.id === this.visibleActionsId}>
                  <el-button
                    id={'edit-'+ row.id}
                    icon="el-icon-edit"
                    onClick={() => this.openEditModal(row.id)}
                    class="table-action-button icon-blue"
                  />
                  <el-button
                    id={'delete-'+row.id}
                    icon="el-icon-delete"
                    onClick={() => this.deleteOperation(row.id)}
                    class="table-action-button icon-red"
                  />
                </div>
              ]
            }
          }
        }
      ]
    };
  },

  components: {
    CreateForm,
    EditForm
  },

  computed: {
    selectedTenant() {
      return this.$store.state.selectedTenant;
    },
    user() {
      return this.$store.state.auth.user;
    }
  },

  watch: {
    async selectedTenant() {
      this.findCustoms();
      feathersClient.service('channel-memberships').remove(null, {query: {channelName: this.eventChannel}});
      this.joinSocketChannel();
      this.getQueueOptions();
      const dids = await this.queryDidOptions();
      this.numOptions = [...dids];
      this.cidNumOptions = [...dids];
      this.queryMediafileOptions();
      this.queryPhonebookOptions();
    },

    async user() {
      this.findCustoms();
      if(!this.eventChannel){
        this.joinSocketChannel();
      }
      this.getQueueOptions();
      const dids = await this.queryDidOptions();
      this.numOptions = [...dids];
      this.cidNumOptions = [...dids];
      this.queryMediafileOptions();
      this.queryPhonebookOptions();
    },

    numQuery: debounce(async function() {
      this.numOptions = await this.queryDidOptions(this.numQuery);
    }, 500),

    cidNumQuery: debounce(async function() {
      this.cidNumOptions = await this.queryDidOptions(this.cidNumQuery);
    }, 500),

    search: debounce( function () {
      this.searchRecords();
    }, 500)
  },

  methods: {
    ...mapActions("customs", {
      deleteCustoms: "remove",
      createCustoms: "create",
      patchCustoms: "patch"
    }),

    doExport(){
      const data = [...this.tableData];
      if(data.length){

        const writeData = data.map(item => ({
          name: item.name,
          type: this.typeLookup(item.ctId)
        }));

        const options = {
          filename: 'custom_destinations',
          showLabels: true,
          headers: ['Name', 'Type']
        }

        const csvExporter = new ExportToCsv(options);
        csvExporter.generateCsv(writeData);
      }
    },

    searchRecords() {
      if(this.search.length){
        this.tableData = this.allRecords.filter(
          data =>
            data.name.toLowerCase().includes(this.search.toLowerCase() ||
            data.customType.name.toLowerCase().includes(this.search.toLowerCase()))
        );
      } else{
        this.tableData = [...this.allRecords];
      }
      this.total = this.tableData.length;
    },

    //General Form and Table Operations
    cellClicked(data){
      if(data.column.property !== 'actions'){
        this.openEditModal(data.row.id);
      }
    },

    rowHover(data){
      this.visibleActionsId = data.row.id;
    },

    rowLeave(){
      this.visibleActionsId = "";
    },

    openCreateModal() {
      this.createVisible = true;
      this.clearFormFields = false;
    },

    openEditModal(id) {
      this.editVisible = true;
      this.clearFormFields = false;
      feathersClient
        .service("customs")
        .get(id)
        .then(res => {
          this.selectedCustomDestination = res;
          this.editVisible = true;
        });
    },

    findCustoms(){
      this.tableLoading = true;
      feathersClient.service('customs').find({
        query: {
          tenantId: this.selectedTenant.id
        }
      }).then( res => {
        this.tableData = [...res];
        this.allRecords = [...res];
        this.total = res.length;
        this.tableLoading = false;
      }).catch( () => {
        this.tableLoading = false;
      })
    },

    createOperation(params) {
      const createBody = { ...params };
      console.log(createBody);

      this.$confirm("Create custom destination?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.createProcessing = true;
          this.createCustoms(createBody)
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Created successfully!",
                type: "success"
              });
              this.createProcessing = false;
              this.clearFormFields = true;
              this.cancelOperation("create");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.createProcessing = false;
            });
        })
        .catch(() => true);
    },

    editOperation(editBody) {
      console.log(editBody);
      this.$confirm("Save custom destination?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.editProcessing = true;

          this.patchCustoms([this.selectedCustomDestination.id, editBody])
            .then(() => {
              this.$notify({
                title: "Success",
                message: "Edited successfully!",
                type: "success"
              });
              this.editProcessing = false;

              this.clearFormFields = true;
              this.cancelOperation("edit");
            })
            .catch(error => {
              this.clearFormFields = false;

              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.editProcessing = false;
            });
        })
        .catch(() => true);
    },

    cancelOperation(type) {
      this.clearFormFields = true;
      if (type === "create") {
        this.createVisible = false;
      } else if (type === "edit") {
        this.editVisible = false;
      }
    },

    deleteOperation(id) {
      this.$confirm("Delete custom destination?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning"
      })
        .then(() => {
          this.deleteProcessing = true;

          this.deleteCustoms(id)
            .then(() => {
              this.deleteProcessing = false;
              this.$notify({
                title: "Success",
                message: "Deleted successfully!",
                type: "success"
              });
            })
            .catch(error => {
              if (error.hasOwnProperty("errors")) {
                this.$notify({
                  title: error.message,
                  message: error.errors[Object.keys(error.errors)[0]],
                  type: "error"
                });
              } else {
                this.$notify({
                  title: error.name,
                  message: error.message,
                  type: "error"
                });
              }

              this.deleteProcessing = false;
            });
        })
        .catch(() => true);
    },

    getQueueOptions() {
      feathersClient.service('queues').find({
        query: { tenantId: this.selectedTenant.id, $sort: { name: 1 } }
      }).then(res => {
        this.queueOptions = [...res];
      });
    },

    async queryDidOptions(queryStr) {
      const didParams = {
        query: {
          tenantId: this.selectedTenant.id,
          allowEmergency: "",
          $limit: 25
        }
      };

      if (queryStr) {
        didParams.query.$or = [{ number: { $like: `%${queryStr}%` } }];
      }

      return await feathersClient.service('dids').find(didParams);
    },

    remoteSearchNums(query) {
      if (query) {
        this.numQuery = query;
      }
    },

    remoteSearchCidNums(query) {
      if (query) {
        this.cidNumQuery = query;
      }
    },

    queryMediafileOptions() {
      feathersClient.service('mediafiles').find({
        query: {
          tenantId: this.selectedTenant.id,
          $sort: {
            name: 1
          }
        }
      }).then(res => {
        this.mediafileOptions = [...res];
      });
    },

    queryPhonebookOptions() {
      feathersClient.service('phonebooks').find({
        query: {
          tenantId: this.selectedTenant.id,
          $sort: {
            name: 1
          }
        }
      }).then(res => {
        this.phonebookOptions = [...res];
      });
    },

    typeLookup(value){
      const map = {
        1: 'Forward call to',
        2: 'Alter caller id',
        24: 'Read a tag',
        28: 'Tag a call',
        30: 'Send call to queue at position',
        34: 'Read variable from HTTP request',
        109: 'Route by previous call',
        121: 'Send a text message',
        127: 'DB lookup'
      }
      return map[value] ? map[value] : '';
    },

    joinSocketChannel(){
      const channelService = feathersClient.service('channel-memberships');
      const data = {
        roomType: 'admins',
        tenantId: this.selectedTenant.id
      };
      channelService.create(data).then(res => {this.eventChannel = `${data.roomType}/${data.tenantId}`});
    },

    removeListeners(){
      feathersClient.service('customs').removeListener('patched');
      feathersClient.service('customs').removeListener('created');
      feathersClient.service('customs').removeListener('removed');
      globalEventBus.$off('appReconnected');
    }
  },

  async created() {
    const dids = await this.queryDidOptions();
    this.numOptions = [...dids];
    this.cidNumOptions = [...dids];
    this.getQueueOptions();
    this.queryMediafileOptions();
    this.queryPhonebookOptions();

    //event listeners
    //monitor socket connection and reconnect to channel
    globalEventBus.$on('appReconnected', () => {
      this.joinSocketChannel();
    });

    //record was edited
    //always refresh did destination options
    feathersClient.service('customs').on('patched', (data) => {
      const updateIndex = this.tableData.findIndex(item => item.id === data.id);
      const updateAllIndex = this.allRecords.findIndex(item => item.id === data.id);
      if(updateIndex >= 0){this.tableData.splice(updateIndex, 1, data);}
      if(updateAllIndex >= 0){ this.allRecords.splice(updateAllIndex, 1, data);}
    });

    //record was created
    feathersClient.service('customs').on('created', (data) => {
      this.tableData.push(data);
      this.allRecords.push(data);
    });

    //record was deleted
    feathersClient.service('customs').on('removed', (data) => {
      const indexToRemove = this.tableData.findIndex(item => item.id === data.id);
      const indexAllToRemove = this.allRecords.findIndex(item => item.id === data.id);
      if(indexToRemove >= 0){this.tableData.splice(indexToRemove, 1);}
      if(indexAllToRemove >= 0){this.allRecords.splice(indexAllToRemove, 1);}
    });

  },

  mounted() {
    if (this.user) {
      this.findCustoms();
      this.joinSocketChannel();
    }
  },

  beforeDestroy() {
    this.removeListeners();
    feathersClient.service('channel-memberships').remove(null, {query:{channelName: this.eventChannel}});
  }
};
</script>
